export default __webpack_public_path__ + "static/media/SEC1840.34I-40787_-24101_0.ab8983c3.jpg";